import React from 'react';
import Meta from "../components/Meta";
import PageBanner from '../components/PageBanner';
import PricingList from '../components/PricingList';

const Pricing = () => {
    return (
        
        <div className="pricing-main">
            <Meta title="Pricing - THE CUTTING BAR" />
            <PageBanner imageUrl="assets/images/background/2.jpg" />
            <PricingList />
        </div>
    );
}

export default Pricing;
